<template>
  <div class="room-nrk" >
        <div class="d-flex justify-content-between">
            <div class="room-title">
                {{discount?'优惠房':'用房需求'}}
                <span v-if="discount">(可以设置优惠房减免总金额)</span> 
            </div>
            <div class="translation" v-if="room_need.length>0">
                <el-button  icon="el-icon-edit-outline"  size="mini" :type="batchMode=='1'?'primary':''"  @click="batchModeOpen(1)">批量修改</el-button>
                <el-button  icon="el-icon-folder-add"  size="mini" :type="batchMode=='2'?'primary':''"  @click="batchModeOpen(2)">批量增加</el-button>  
            </div>
            <el-button class=" addition" icon="el-icon-plus" size="mini" type="primary">新增日期
                <el-date-picker 
                v-model="addDate"
                type="dates" 
                value-format="timestamp"
                :editable="false"
                :picker-options="forbiddenStartTime()"
                @change="submitPost"
                :clearable="false"
                class="addition-date"/>
            </el-button>
        </div>
        <div class="room-Type mt-3" v-if="room_need.length>0">
            <div class="room-rnk" ref="scrollRoom">
                <!--房型标题-->
                <ul class="roomtypetitle" >
                    <li :style="{width:modify?'20%':'30%'}" class="mr-2">入住日期</li>
                    <li class="roomtypetitle-information" :class="{'w-80':modify}">
                        <div v-for="(item,index) in modify?modifyroomtypetitle:roomtypetitle" :key="index" :style="{width:item.width}">
                            {{discount&&item.name=='单价'?'优惠单价':item.name}}
                        </div>
                    </li>
                </ul>
                <div>
                    <el-checkbox-group v-model="batckedRows">
                        <div class="roomtypetitle mt-3 roomtypetitle-bottom" v-for="(data,i) in room_need" :key="data.value">
                            <el-checkbox class="mr-2 checkbox" :label="i" v-if="batchMode=='2'">{{  }}</el-checkbox>
                            <!--入住日期-->
                            <div :style="{width:modify?'20%':'30%'}" class="mr-2" >
                                <el-date-picker 
                                v-model="data.date"
                                type="date" 
                                value-format="timestamp"
                                :editable="false"
                                :clearable="false"
                                :picker-options="forbiddenStartTime(data,i)"
                                @input="onFieldChange"
                                :class="{ roomRed: isFieldError(i, null, 'date') }"
                                placeholder="选择日期"/>
                            </div>
                            <div class="roomtypetitle-list" :class="{'w-80':modify}">
                                <!--房间类型、间数、操作-->
                                <div v-for="(item,index) in data.offer_info"  :key="index" class="d-flex w-100" :class="{'mt-2':index>0}">
                                    <el-checkbox class="checkbox"  :label="`${i},${index}`" v-if="batchMode=='1'">{{  }}</el-checkbox>
                                    <!--房间类型-->
                                    <el-select  
                                        v-model="item.type" 
                                        placeholder="请选择类型" 
                                        @input="onFieldChange"
                                        class="w-50"  
                                        :class="{ roomRed: isFieldError(i, index, 'type') }" v-if="!modify">
                                        <el-option
                                        v-for=" i in $GVAR.roomStyle"
                                        :key="i.id"
                                        :label="i.name"
                                        :value="i.id">
                                        </el-option>
                                    </el-select>
                                    <!--房间类型-->
                                    <el-select 
                                        :value="item.offer_title"
                                        :class="{ roomRed: isFieldError(i, index, 'offer_title') }"
                                        @change="getId($event,i,index)"
                                        @blur="blurs($event,i,index)"
                                        filterable
                                        allow-create
                                        default-first-option
                                        placeholder="选择或输入房型"
                                    class="w-50 ml-2"  v-if="modify">
                                    <template>
                                        <el-option
                                            v-for="roomItem in StoreRoomList"
                                            :key="roomItem.title"
                                            :label="roomItem.title"
                                            :value="`${roomItem.id},${roomItem.title},${roomItem.type}`"
                                        >
                                        </el-option>
                                    </template>
                                    </el-select>
                                    <!--早餐-->
                                    <el-select 
                                        v-model="item.breakfast"
                                        :class="{ roomRed: isFieldError(i, index, 'breakfast') }"
                                        @change="changeBreakfastType($event,i,index)"
                                        @blur="blurBreakfastType($event,i,index)"
                                        filterable
                                        allow-create
                                        default-first-option
                                        placeholder="选择或输入早餐"
                                    class="w-50 ml-2"  v-if="modify">
                                    <template >
                                        <el-option
                                            v-for="roomItem in $GVAR.breakfastTypeArr"
                                            :key="roomItem.name"
                                            :label="roomItem.name"
                                            :value="`${roomItem.id},${roomItem.name}`"
                                        >
                                        </el-option>
                                    </template>
                                    </el-select>
                                    <!--间数-->
                                    <el-input 
                                        type="number"  
                                        v-model.number="item.room_num" 
                                        @mousewheel.native.prevent
                                        @input="onFieldChange" 
                                        class="ml-2 w-40" 
                                        :class="{ roomRed: isFieldError(i, index, 'room_num') }"
                                        placeholder="间数">
                                        <span slot="append">间</span>
                                    </el-input>
                                    <!--单价-->
                                    <el-input 
                                    placeholder="金额"
                                    v-model.number="item.offer_price"  
                                    class=" ml-2 w-40"
                                    @input="onFieldChange"
                                    :class="{ roomRed: isFieldError(i, index, 'offer_price') }"
                                    type="number" v-if="modify">
                                        <!-- <span slot="prepend">&yen;</span> -->
                                        <span slot="append" class="lisxn">元/晚</span>
                                    </el-input>
                                    <!--操作-->
                                    <div class="w-30 deletes">
                                        <el-tooltip class="item" effect="dark" content="新增类型" placement="top">
                                            <i class="el-icon-circle-plus text-primary"  @click="addMeeting(i)" v-if="index==0"></i>
                                        </el-tooltip>
                                        <i class="el-icon-delete" @click="splicse(i,index)" ></i>
                                        <!-- <el-button  class="mt-1" type="danger" size="mini" @click="splicse(i,index)">删除</el-button> -->
                                    </div>
                                </div>
                                <!-- <div class="d-flex   mt-3">
                                    <el-button class="mr-3" icon="el-icon-plus" type="primary" size="mini" @click="addMeeting(i)">新增类型</el-button>
                                </div> -->
                            </div>
                        </div>        
                    </el-checkbox-group>
                </div>
            </div>
            <div class="batchButton" v-if="batchMode>0">
                <div class="selectAll">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="batckAll" @change="batchAllChange">全选</el-checkbox>
                </div>
                <el-button size="mini" type="primary" @click="batchSubmit">确认选择</el-button>  
            </div>
        </div>
        <!--提示信息-->
        <div class="room-Type mt-3 prompt" v-else>
            <img src="/images/order/icon_25.png">
            <span>请新增{{discount?'优惠房':'用房'}}日期</span>
        </div>
        <!--批量修改弹窗-->
        <el-dialog  
            title="批量修改房间类型"
            :visible.sync="batchVisible"
            :width="modify?'800px':'600px'"
            :close-on-click-modal="false"
            top="12%"
        >
            <BatcDialog :modify="modify" @batchSubmit="item=>batcoffer_info=item" :isSubmit="batcbmit" ref="batcDialog"></BatcDialog>
            <span slot="footer" class="dialog-footer">
                <el-button @click="batchVisible = false">返 回</el-button>
                <el-button type="primary" @click="batchSubmitConfirm()">确 定</el-button>
            </span>
        </el-dialog>
  </div>
</template>

<script>
import BatcDialog from './Comp/BatcDialog.vue'
import { mapState} from 'vuex'
export default {
  name: '',
  components: {BatcDialog},
  props: {
    room_need_clone: {
      type: Array,
      default: () => []
    },
    //是否是修改订单
    modify: {
      type: Boolean,
      default: false
    },
    //是否是优惠房
    discount: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
        room_need:[],
        addDate:'',                              //新增日期
        meetObjfs:{
            date:'',
            offer_info:[
                { type:'',room_num:'',offer_price:'',offer_id:'',offer_title:'',breakfast:''},
            ],
            date:'',
            offer_info:[
                { type:'',room_num:'',offer_price:'',offer_id:'',offer_title:'',breakfast:''},
            ]
        },
        roomtypetitle:[
            {name:'类型',width:'50%'},
            {name:'间数',width:'50%'},
            {name:'操作',width:'30%'},
        ],
        modifyroomtypetitle:[
            {name:'房型',width:'50%'},
            {name:'早餐',width:'50%'},
            {name:'间数',width:'40%'},
            {name:'单价',width:'40%'},
            {name:'操作',width:'30%'},
        ],
        // 错误标记：精准记录 行+子项+字段名
        errorMap: {},
        isSubmit: false,
        //批量修改当前修改的模式1,为批量修改2为批量增加
        batchMode: '',
        isIndeterminate: true,                      //是否半选
        batckedRows: [],                            //批量选择数组
        batckAll: false,                            //全选
        batchVisible: false,                        //批量修改弹窗是否显示
        batcoffer_info:[],                          //批量修改值
        batcbmit:false,                             //开启提示
    };
  },
  computed: {
    ...mapState(['StoreRoomList']),
  },
  watch: {
    room_need_clone: {
        handler(newVal) {
            this.room_need = JSON.parse(JSON.stringify(newVal));
        },
        deep: true, // 开启深度监听
        immediate: true // 一进页面就执行一次
    }
  },
  created() {},
  mounted() {},
  methods: {
    //新增一个日期
    submitPost(e){
        if(e.length==0) return;
        e.forEach(item=>{
            let data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfs)));
            data.date = item;
            this.room_need.push(data);
        })
        // let data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfs)));
        // data.date = e;
        // this.room_need.push(data);
        this.scrollToBottom();
        this.addDate='';
    },
    //添加新的房型
    addMeeting(i){
        let data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfs.offer_info[0])));
        this.room_need[i].offer_info.push(data);
    },
    //删除房型
    splicse(i,index){
        if( this.room_need[i].offer_info.length==1){
            this.room_need.splice(i,1)
        }else{
            this.room_need[i].offer_info.splice(index,1)
        }
    },
    // 滚动到底部
    scrollToBottom() {
        // 等到 DOM 更新完毕再滚动
        this.$nextTick(() => {
        const el = this.$refs.scrollRoom;
        console.log(el);
        if (el) {
            // 平滑滚动到底部
            el.scrollTop = el.scrollHeight;
        }   
        });
    },
    //确认订单
    submitForm(e){
        this.isSubmit = true;
        const valid = this.validateAll();
        if (!valid) {
            this.$message.error('请填写完整的房间需求信息');
        return false;
        }
        return {[this.discount?'discount_need':'room_need']:this.room_need};
    },
    // 全局校验，逐个字段判断
    validateAll() {
        this.errorMap = {};
        let pass = true;
        console.log(this.room_need);
        this.room_need.forEach((row, rowIdx) => {
        // 校验 date
        if (!row.date) {
            this.setFieldError(rowIdx, null, 'date');
            pass = false;
        }
        // 遍历 offer_info 每一项、每一个字段
        row.offer_info.forEach((item, offerIdx) => {
            const fields = this.modify?['type', 'room_num','offer_price', 'offer_title','breakfast']:['type', 'room_num'] 
            fields.forEach(field => {
            // 去除首尾空格判断空值
            if (!item[field] || String(item[field]).trim() === '') {
                this.setFieldError(rowIdx, offerIdx, field);
                pass = false;
            }
            });
        });
        });
        return pass;
    },
    // 记录错误字段：key 格式 row-idx|offer-idx|field
    setFieldError(rowIdx, offerIdx, field) {
        const key = offerIdx === null 
        ? `${rowIdx}|date` 
        : `${rowIdx}|${offerIdx}|${field}`;
        this.errorMap[key] = true;
    },
    // 输入时实时更新错误状态
    onFieldChange() {
        if (!this.isSubmit) return;
        this.validateAll();
    },

    // 判断单个字段是否标红
    isFieldError(rowIdx, offerIdx, field) {
        if (!this.isSubmit) return false;
        const key = offerIdx === null 
        ? `${rowIdx}|date` 
        : `${rowIdx}|${offerIdx}|${field}`;
        return !!this.errorMap[key];
    },
    // 禁用日期的回调函数，根据当前对象组和禁用日期的索引判断是否禁用日期
    forbiddenStartTime(item) {
        return {
          // 在禁用日期的回调中使用index
          disabledDate: (date) => {
            let meetObj=[...this.room_need];
            //判断是否有重复时间-重复布局 
            const allIndexes = meetObj.reduce((acc, user, index) => {
                acc.push(meetObj[index]); // 符合条件则添加索引到数组
            //   if (user.type === item.type&&user.timeslot === item.timeslot) {
            //     console.log(user,acc)
            //     acc.push(meetObj[index]); // 符合条件则添加索引到数组
            //   }
              return acc;
            }, []); // 初始值为空数组
            //判断禁用值
            let  hasTarget = allIndexes.some(user => user.date === date.getTime());
            // ===== 新增：过期日期判断逻辑 =====
            let isPast = false;
            if (!this.modify) {
                const today = new Date();
                // 置零时分秒，只对比日期
                today.setHours(0, 0, 0, 0);
                const targetDay = new Date(date);
                targetDay.setHours(0, 0, 0, 0);
                // 选中日期 < 今天 → 禁用
                isPast = targetDay.getTime() < today.getTime();
            }
            return hasTarget|| isPast;
          }
        }
    },
    // 房型相关
    getId(val,i,index){
        let [id, name,type] = val.split(',');
        let room_offer={...this.room_need[i].offer_info[index],offer_id:id?id:'0',offer_title:name?name:id,type:type}
        this.$set(this.room_need[i].offer_info,index,room_offer);
    },
    blurs(val,i,index){
        let StoreRoomList=this.StoreRoomList;
        let room_offer=StoreRoomList.find(item=>item.title==val.target.value);
        if(val.target.value&&!room_offer&&val.target.value!=this.room_need[i].offer_info[index].offer_title){
            let room_offer={...this.room_need[i].offer_info[index],offer_id:'0',offer_title:val.target.value}
            this.$set(this.room_need[i].offer_info,index,room_offer);
        }
    },
    //早餐类型
    changeBreakfastType(val,i,index){
        let [id, name] = val.split(',');
        let room_offer={...this.room_need[i].offer_info[index],breakfast:name};
        this.$set(this.room_need[i].offer_info,index,room_offer);
    },
    blurBreakfastType(val,i,index){
        if(val.target.value){
        let room_offer={...this.room_need[i].offer_info[index],breakfast:val.target.value};
        this.$set(this.room_need[i].offer_info,index,room_offer);
        }
    },
    /** 
     * 批量模式方法
     **/
    //开启批量修改模式
    batchModeOpen(mode){
        this.batchMode = this.batchMode==mode?'':mode;
        this.batckedRows = [];
    },
    //确认批量修改
    batchSubmit(){
        console.log(this.batckedRows)
        if(this.batckedRows.length==0){
            this.$message.error(`请选择批量${this.batchMode==1?'修改':'增加'}的房间`);
            return false;
        }
        this.batchVisible = true;
    },
    //批量修改确认
    batchSubmitConfirm(){
        let batcoffer_info=this.batcoffer_info
        let pass = true;
        const fields = this.modify?['type', 'room_num','offer_price', 'offer_title','breakfast']:['type', 'room_num'] 
        fields.forEach(field => {
        // 去除首尾空格判断空值
            if (!batcoffer_info[field] || String(batcoffer_info[field]).trim() === '') {
                pass = false;
            }
        })
        if(pass){
            let batckedRows=this.batckedRows;
            if(this.batchMode==1){
                //批量修改
                batckedRows.forEach(item=>{
                    let [i,index]=item.split(',');
                    this.room_need[i].offer_info[index]=batcoffer_info;
                })
                
            }else{
                //批量增加
                batckedRows.forEach(item=>{
                    this.room_need[item].offer_info.push(batcoffer_info);
                })

            }
            this.batchVisible = false;
            this.isIndeterminate = true;
            this.batchMode='';
            this.batckedRows='';
            this.batcoffer_info=[];
            //清空批量修改信息框
            this.$refs.batcDialog.clearInfo();
        }else{
            this.batcbmit=true;
            this.$message.error('请填写完整信息');
        }

    },
    //全选
    batchAllChange(val){
        let batckedRows=[];
        //全选模式
        if(this.batchMode==1){
            if(val){
                this.batckedRows = this.room_need.map((item,index)=>{
                    item.offer_info.map((offer,i)=>{
                        batckedRows.push(`${index},${i}`);
                    })

                });
            }
            this.batckedRows = batckedRows;
        };
        if(this.batchMode==2){
            this.batckedRows= val ? this.room_need.map((item,index)=>index) : [];
        };
         this.isIndeterminate = false;
    },
  }
};
</script>

<style lang="scss" scoped>
    .prompt{
        text-align: center;
        img{
            width: 80px;
            height: 80px;
            display: inline-block;
        }
        span{
            display: block;
            color: #999;
        }
    }
    .room-Type{
        background-color: #fff;
        box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
        width: 94%;
        padding: 2% 3%;
        border-radius: 6px;
        text-align: center;
    }
    .room-title{
        font-size: 18px;
        font-weight: bold;
        color: #333;
        position: relative;
        padding-left: 12px;
        &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 4px;
            height: 20px;
            width: 4px;
            background-color: var(--smtc-color-primary);
            border-radius: 50px;
        }
    }
    .roomtypetitle{
        display: flex;
        width: 100%;
        >li{
            text-align: center;
        }
    }
    .roomtypetitle-information{
        width: 70%;
        display: flex;
        text-align: center;
    }
    .roomtypetitle-list{
        width: 70%;
        display: flex;
        text-align: center;
        flex-wrap: wrap;
    
    }
    .roomtypetitle-bottom{
        border-bottom: 1px #eee solid;
        padding-bottom: 14px;
    }
    .room-Type-footer{
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
    .deletes{
        text-align: center;
        display: flex;
        justify-content: center;
        color: red;
        font-size: 16px;
        margin-top: 10px;
        cursor: pointer;
        i:nth-child(1){
            margin-right: 5px;
        }
    }
    .room-rnk{
        max-height: 600px;
        overflow-y: auto;
        scroll-behavior: smooth; 
    }
    .room-title span{
        font-size: 14px;
        font-weight: normal;
    }
    .translation{
        margin-left: auto;
        margin-right    : 10px;
    }
    .addition{
        position: relative;
        overflow: hidden;
        width: 100px;
    }
    .addition-date{
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
    }
    .checkbox{
        margin-top:12px
    }
    .batchButton{
        display: flex;
        justify-content:flex-end;
        margin-top: 10px;
    }
    .selectAll{
        margin-right: 10px;
        margin-top: 6px;
    }
</style>
<style>
    .room-nrk .el-date-editor.el-input{
        width: 100%;
    }
    .room-nrk .el-input__inner{
        text-align: center;
    }
    .room-nrk .el-input-group__append,.room-nrk .el-input--suffix .el-input__inner ,.room-nrk .meeting-type .el-input__inner{
        font-size: 12px;
    }
    .roomRed .el-input__inner,
    .roomRed .el-date-editor .el-input__inner {
        border-color: #F56C6C !important;
    }
    .addition-date .el-input__inner{
        cursor: pointer;
    }
    .checkbox .el-checkbox__inner{
            border: 1px solid var(--smtc-color-primary);
    }
</style>